import { apiClient } from "./apiClient";

/**
 * The transport for flow events (#379).
 *
 * ── WHY THIS IS ITS OWN FILE ──
 *
 * flowTelemetry holds the buffer and the rules, and useFlow imports it,
 * so every screen that measures a flow inherits whatever that file
 * depends on. Keeping HTTP out of it and wiring this in at startup means
 * a measurement never decides what a page depends on.
 *
 * It matters more on mobile, where the same chain reaches a native
 * module -- but the split is the same on both, because the two telemetry
 * copies are a parity pair and a rule that holds for a reason on one
 * platform should not quietly differ on the other.
 *
 * MIRRORS mobile/src/services/flowApi.js, which adds the one thing this
 * does not need: an online check before spending a request.
 */
export function postFlowEvents(events) {
  return apiClient.post("/analytics/flows", { events }).then((r) => r.data);
}
